import React, { useCallback, useEffect, useState } from 'react';
import Cell from '../widgets/Cell';
import useMyFormState from '../../hooks/useMyFormState';
import { isValidEmail, isValidPersonName, isValidPhone, isValidUsername } from '../../hooks/useValidation';
import { useOperatorContext } from '../login/OperatorContextProvider';
import { useOrganListenerContext } from '../../providers/OrganListenerContextProvider';
import useWebSocketCaller from '../../hooks/useWebSocketCaller';
import './Profile.css'

// --------------------------------------------------------   STATIC   -----------------------------------------------------------------------------------------//
const fullName = (operator) => [operator.firstName, operator.midName, operator.lastName].filter(str => Boolean(str) && str.toLowerCase() !== 'false').join(' ');


// -------------------------------   My Organizational Profile   ------------------------//
const MyOrganProfile = () => {
  const {operator, setOperator}                                                     = useOperatorContext();
  const {myAccountData, myTeamData, myProfileUpdated}                               = useOrganListenerContext();
  const {handleAddError, handleRemoveError, getFormModel, updateFormField, reload}  = useMyFormState();  
  const {sendMessage}                                                               = useWebSocketCaller();

  const [model, setModel] = useState({});

  // TODO: Remove this state? The Refresh is not used here.
  // const [fresh, setFresh] = useState(false);
  // const refreshMe  = useCallback(()=>setFresh(prev => !prev), []);
  
  useEffect(()=>{
    if (myProfileUpdated) {
      setOperator(prev => ({...prev, [myProfileUpdated.fieldName]:myProfileUpdated.fieldValue}));
    }
  }, [myProfileUpdated, setOperator]);

  // ---[  Save User Field  ]---
  //
  // TODO: Use Token instead of user-id!
  const saveUserField = useCallback(async (fieldName, fieldValue) => {
    sendMessage('save-user-field', {'userId': operator.userId, 'fieldName': fieldName, 'fieldValue': fieldValue});
    return true;
  }, [sendMessage, operator.userId]);
  
  // const teamName = myTeamData.name;
  // const teamPlanId   = myTeamData?.planId ? myTeamData.planId : myAccountData?.planId ? `${myAccountData?.planId} from Account` : '?';
  // const accountPlanId= myAccountData?.planId;
  // const accountWebUsers = myAccountData?.totalWebUsers;
  // const accountName = myAccountData?.name;

  useEffect(()=>{
    if (operator) {            
      updateFormField('fullName', fullName(operator));
      updateFormField('username', operator.username);
      updateFormField('firstName', operator.firstName);
      updateFormField('midName', operator.midName);
      updateFormField('lastName', operator.lastName);
      updateFormField('email', operator.email);
      updateFormField('phone', operator.phone);
    }

    if (myTeamData) {
      updateFormField('teamName', myTeamData.name);
      updateFormField('teamPlanId', myTeamData?.planId ? myTeamData.planId : myAccountData?.planId ? `${myAccountData?.planId} by Account` : '?');
    }

    if (myAccountData) {
      updateFormField('accountPlanId', myAccountData?.planId);
      updateFormField('accountName', myAccountData.name);
      updateFormField('totalWebUsers', myAccountData?.totalWebUsers);
    }

    setModel({...getFormModel()});
    //refreshMe();

  },[operator, myTeamData, myAccountData, updateFormField, getFormModel]);
  

  useEffect(()=>{
    setModel({...getFormModel()});
  }, [reload, getFormModel])  



  //------   RENDER   ------


  return (
    <div className='profile'>
      <div className='profileUserTitle'>{model.fullName}</div>
      <div className='userDetails'>
        <div className='userGridLabel'>Username</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='username' saveMe={saveUserField} validateMe={isValidUsername} isLocked={true} >{model.username}</Cell>
        </div>
        <div></div>
        <div className='userGridLabel'>First Name</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='firstName' saveMe={saveUserField} validateMe={isValidPersonName} >{model.firstName}</Cell>
        </div>
        <div></div>
        <div className='userGridLabel'>Mid Name</div>
        <div className='userGridValue'>          
          <Cell addError={handleAddError} removeError={handleRemoveError} path='midName' saveMe={saveUserField} validateMe={isValidPersonName}>{model.midName}</Cell>
        </div>
        <div></div>
        <div className='userGridLabel'>Last Name</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='lastName' saveMe={saveUserField} validateMe={isValidPersonName}>{model.lastName}</Cell>
        </div>
        <div></div>
        <div className='userGridLabel'>My Email</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='email' saveMe={saveUserField} validateMe={isValidEmail}>{model.email}</Cell>
        </div>
        <div style={{fontSize: 11}}>Optional, for notifications</div>
        <div className='userGridLabel'>My Phone</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='phone' saveMe={saveUserField} validateMe={isValidPhone} >{model.phone}</Cell>
        </div>
        <div style={{fontSize: 11}}>Optional, for notifications</div>
      </div>
      
      <div className='profileUserTitle' style={{marginTop: 32}}> {model.teamName} </div>
        <div className='userDetails'>
        <div className='userGridLabel'>Team Plan</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='teamPlanId' saveMe={()=>{}} /*validateMe={ignoreValid}*/ isLocked={true} >{model.teamPlanId}</Cell>
        </div>
      </div>

      <div className='profileUserTitle' style={{marginTop: 32}}> {model.accountName} </div>

      <div className='userDetails'>
        <div className='userGridLabel'>Account Plan</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='accountPlanId' saveMe={()=>{}} /*validateMe={ignoreValid}*/ isLocked={true} >{model.accountPlanId}</Cell>
        </div>

        <div></div>
        <div className='userGridLabel'>Web Users</div>
        <div className='userGridValue'>
          <Cell addError={handleAddError} removeError={handleRemoveError} path='totalWebUsers' saveMe={()=>{}} /*validateMe={ignoreValid}*/ isLocked={true} >{model.totalWebUsers}</Cell>
        </div>
      </div>
    </div>
  );
}

export default React.memo(MyOrganProfile);